















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import UnauthorizedPage from "@/views/UnauthorizedPage.vue";

@Component({ components: { UnauthorizedPage } })
export default class Home extends Vue {
  private error = null;
  private user = {
    email: "",
    password: "",
  };

  submit() {
    store.dispatch("login", this.user).then(
      (user) => {
        window.location.reload();
      },
      (err) => {
        this.error = err;
      }
    );
  }

  requestAccess() {
    this.$router.push({ name: "new_request" });
  }
}
